export default __webpack_public_path__ + "static/media/LoadIcon.f56726af.svg";